/** @jsx jsx */
import React from "react"
import { jsx, useColorMode, Link as TLink } from "theme-ui"
import { Link } from "gatsby"
import useMinimalBlogConfig from "../hooks/use-minimal-blog-config"
import replaceSlashes from "../utils/replaceSlashes"
import ColorModeToggle from "./colormode-toggle"
import ItemTags from "@lekoarts/gatsby-theme-minimal-blog/src/components/item-tags"


type NavigationProps = {
  nav: {
    title: string
    slug: string
    selected: boolean
  }[]
}

const Navigation = ({ nav }: NavigationProps) => {
  const { basePath } = useMinimalBlogConfig()
  const [colorMode, setColorMode] = useColorMode()
  const isDark = colorMode === `dark`
  const toggleColorMode = (e: any) => {
    e.preventDefault()
    setColorMode(isDark ? `light` : `dark`)
  }

  return (
    <React.Fragment>
      <div 
          sx={{ borderRadius: `50px`, 
                background: isDark ? `#313949` :`#eeeeee`,
                boxShadow: isDark ? `9px 9px 30px #292f3d, -9px -9px 30px #394355` : `9px 9px 28px #e0e0e0, -9px -9px 28px #fcfcfc`,
                padding: `10px 20px 10px 20px`,
              }}
      >
      {nav && nav.length > 0 && (
        <nav sx={{ "a:not(:last-of-type)": { mr: 3 }, fontSize: [1, `18px`] }}>
          {nav.map((item) => (
            <TLink key={item.slug}
                   as={Link}
                   activeClassName="active"
                   to={replaceSlashes(`/${basePath}/${item.slug}`
            )}>
              <div 
                  sx={{
                        display: `inline-block`, 
                        //position: `relative`,
                        //cursor: `pointer`,
                        padding: `10px clamp(5px, 4vw, 50px) 10px clamp(5px, 4vw, 50px)`,
                        "&:hover": {
                          display: `inline-block`,
                          position: `relative`,
                          transition: `all ease-in-out 0.25s`,
                          borderRadius: `50px`,
                          background: isDark ? `#313949` :`#eeeeee`,
                          boxShadow: isDark ? `9px 9px 30px #292f3d, -9px -9px 30px #394355` : `9px 9px 28px #e0e0e0, -9px -9px 28px #fcfcfc`,
                          padding: `10px clamp(5px, 4vw, 50px) 10px clamp(5px, 4vw, 50px)`,
                        },
                        
                      }}
                >
                {item.title}
                </div>
            </TLink>
          ))}
        </nav>
      )}
      </div>
    </React.Fragment>
  )
}

export default Navigation
